// Google Tag Manager dataLayer utility wrapper
// All events are pushed to dataLayer for GTM to forward to GA4

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

function pushToDataLayer(data: Record<string, unknown>) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}

/** Track a custom event */
export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  pushToDataLayer({ event: eventName, ...params });
}

/** Set user-level properties (membership_plan, etc.) */
export function setUserProperties(properties: Record<string, unknown>) {
  pushToDataLayer({ event: 'set_user_properties', ...properties });
}

/** Track a page view manually */
export function trackPageView(path: string, title?: string) {
  pushToDataLayer({
    event: 'page_view',
    page_path: path,
    page_title: title || document.title,
  });
}

/** Track standard GA4 ecommerce events (begin_checkout, purchase, view_item, etc.) */
export function trackEcommerce(
  eventName: 'view_item' | 'begin_checkout' | 'purchase',
  params: {
    currency?: string;
    value?: number;
    transaction_id?: string;
    items: Array<{
      item_id?: string;
      item_name: string;
      price?: number;
      quantity?: number;
      item_category?: string;
    }>;
  }
) {
  // Clear previous ecommerce data to avoid contamination
  pushToDataLayer({ ecommerce: null });
  pushToDataLayer({
    event: eventName,
    ecommerce: {
      currency: params.currency || 'USD',
      value: params.value,
      transaction_id: params.transaction_id,
      items: params.items,
    },
  });
}
